// Browser-local cache of preloaded media, keyed by tag-set + content kind.
// Repeat visits with the same selection skip the network entirely (load times
// matter). Single small table; entries expire after 30 minutes.
import Dexie, { type Table } from 'dexie'
import type { MediaItem } from '../types'

interface MediaCacheRow {
  key: string
  items: MediaItem[]
  fetchedAt: number
}

class GoonGalleryDB extends Dexie {
  mediaCache!: Table<MediaCacheRow, string>
  constructor() {
    super('goongallery')
    this.version(1).stores({ mediaCache: '&key, fetchedAt' })
  }
}

export const db = new GoonGalleryDB()

const TTL_MS = 30 * 60_000

const CACHE_VERSION = 'v2'

export function cacheKey(tagIds: string[], kind: string): string {
  return `${CACHE_VERSION}|${kind}|${[...tagIds].sort().join(',')}`
}

export async function getCachedMedia(key: string): Promise<MediaItem[] | null> {
  try {
    const row = await db.mediaCache.get(key)
    if (!row) return null
    if (Date.now() - row.fetchedAt > TTL_MS) {
      await db.mediaCache.delete(key)
      return null
    }
    return row.items
  } catch {
    return null
  }
}

export async function putCachedMedia(key: string, items: MediaItem[]): Promise<void> {
  try {
    await db.mediaCache.put({ key, items, fetchedAt: Date.now() })
  } catch {
    /* cache is best-effort */
  }
}
